export const yearlyMonthlyMonthMixin = {
  computed: {
    currentMonthStr() {
      return this.months[this.currentMonth - 1];
    },
    startDayOfMonth() {
      return new Date(this.currentYear, this.currentMonth - 1, 1).getDay();
    },
    lastDayOfMonth() {
      return new Date(this.currentYear, this.currentMonth, 0).getDate();
    },
    startDaysOfWeek() {
      let currentDate = 1 + (7 - this.startDayOfMonth);
      let startOfWeekArray = [];
      for (let i = currentDate; i <= this.lastDayOfMonth; i += 7) {
        startOfWeekArray.push(i);
      }
      return startOfWeekArray;
    }
  }
};
